import * as organizationConstants from '../constants/organizations';
import { LOCATION_CHANGE } from 'react-router-redux';
import routes from '../helpers/ApplicationRoutes';

const INITIAL_STATE = {
    data: [],
    loading: false,
    error: undefined,
};

export default function reportPage(state = {}, action) {
    switch (action.type) {
        case LOCATION_CHANGE:
            const { pathname } = action.payload;
            const isReportPath = routes.organizationReport.isExactPath(
                pathname,
            );

            if (isReportPath) {
                return {
                    ...INITIAL_STATE,
                    ...state,
                };
            }
            return {
                ...INITIAL_STATE,
            };
        case organizationConstants.REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                error: undefined,
            };
        case organizationConstants.REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: undefined,
                data: action.payload,
            };
        case organizationConstants.REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                data: [],
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reportPageReducer.js